import axios from "../config"

class FriendService{
    axios;
    constructor(){
        this.axios = axios;
    }
    getFriends() {
        let url = `/friends`
        return axios.get(url).then(request => request.data);
    }
    getFriendMessage(messageId,requestFormId,replyId) {
        let url = `/fri/message`
        return axios.get(url,{
            params:{
                messageId,requestFormId,replyId
            }
        }).then(request => request.data);
    }
    addFriendMessage(message) {
        let url = `/fri/message`
        return axios.post(url,message).then(request => request.data);
    }
    updateFriendMessage(message) {
        let url = `/fri/message/${message.privateMessageId}`
        return axios.put(url,message).then(request => request.data);
    }
    deleteFriendMessage(privateMessageId,requestFormId) {
        let url = `/fri/message/${privateMessageId}/${requestFormId}`
        return axios.delete(url).then(request => request.data);
    }
    saveFriendMessagePhoto(formData,requestFormId,localPosition,type){
        let url = `/fri/message/${requestFormId}/photo/${localPosition}/${type}`;
        return axios.put(url, formData,
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            }).then(request => request.data);
      }
      getFriendMessageNextPre(privateMessageId,requestFormId,nextpre) {
        let url = `/fri/message/photo/${privateMessageId}/${requestFormId}/${nextpre}`
        return axios.get(url).then(request => request.data);
    }
    updateFriendLook(message) {
        let url = `/fri/${message.privateMessageId}/${message.requestFormId}/look`
        return axios.put(url).then(request => request.data);
    }
    changeFriendName(userAccountId,receiverId,changeName) {
        let url = `/fri/changename`
        return axios.get(url,{
            params:{
                userAccountId,receiverId,changeName
            }
        }).then(request => request.data);
    }
}

const service = new  FriendService();
export default service;